// extracted by mini-css-extract-plugin
module.exports = {"cls1":"DocumentOutlineItem-ListItem-module--cls1--15y7e","cls2":"DocumentOutlineItem-ListItem-module--cls2--2wOel DocumentOutlineItem-ListItem-module--cls1--15y7e"};